import { ReactElement, JSXElementConstructor, ReactNode, ReactPortal } from "react"

interface Properties {
    id?: string,
    children?: React.ReactNode,
    hideOverflow?: boolean
}

function BaseCard(properties: Properties) {
    const { id, hideOverflow } = {...properties, hideOverflow: true };
    return (
        <div className="card-container">
            <div className="flex-1 rounded-lg p-5 bg-white flex flex-col">
                { properties.children }
            </div>
        </div>
    )
}

export default BaseCard